import React from 'react';
import VisuallyHiddenText from '../../components/VisuallyHiddenText';
import { facebookPath, vimeoPath, instagramPath, youtubePath, twitterPath } from '../../constants';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFacebook,
    faInstagram,
    faXTwitter,
    faYoutube,
    faVimeoV
} from '@fortawesome/free-brands-svg-icons';

const SOCIAL_LINKS = [
    { href: facebookPath, icon: faFacebook, label: 'Facebook' },
    { href: instagramPath, icon: faInstagram, label: 'Instagram' },
    { href: twitterPath, icon: faXTwitter, label: 'Twitter' },
    { href: youtubePath, icon: faYoutube, label: 'YouTube' },
    { href: vimeoPath, icon: faVimeoV, label: 'Vimeo' },
];

/**
 * Self-contained (no external CSS needed) row of social icon links, in
 * Reformed Navy, sized for a comfortable tap target.
 */
export const Social = () => {
    return (
        <div style={{ display: 'flex', alignItems: 'center', gap: '4px', fontSize: '21px', color: 'var(--reformed-navy)' }}>
            {SOCIAL_LINKS.map((social) => (
                <a
                    key={social.label}
                    href={social.href}
                    target="_blank"
                    rel="noreferrer"
                    style={{ color: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '10px' }}
                >
                    <FontAwesomeIcon icon={social.icon} size="xs" aria-hidden="true" />
                    <VisuallyHiddenText>{social.label}</VisuallyHiddenText>
                </a>
            ))}
        </div>
    );
};

export default Social;
